import { Action } from '@ngrx/store';
import { SsrsConfigModel } from '../../models/SsrsConfigModel';

export const GET_SSRS_CONFIG_SUCCESS = '[Report] Get SSRS Config Success';

export class GetSsrsConfigSuccessAction implements Action {
  readonly type = GET_SSRS_CONFIG_SUCCESS;

  constructor(public payload: SsrsConfigModel) {}
}



// WEBPACK FOOTER //
// ./src/app/report/store/actions/GetSsrsConfigSuccessAction.ts